module.exports = __webpack_public_path__ + "img/empty_holiday.fc4602d2.svg";